import features from "./features";

// Define the possible component actions for the reducer to call.
export const ACTIONS = {
  INITIALIZE_FORM: "initializeForm",
  CONDITION_TOGGLE: "conditionToggle",
  COMMENTS_INPUT: "commentsInput",
  FEATURE_SELECTED: "featureSelected",
  PROCESSING_IMAGE: "toggleProcessingImage",
  SET_STATUS: "setStatus",
  UPDATE_IMAGE_OBJECTS: "updateImages",
  REMOVE_PHOTO: "removePhoto",
  SET_PREVIEW: "setPreview",
  SET_ADDRESS: "setAddress",
  RESET_STATE: "resetState",
  FORM_IMAGE_ERROR: "formImageError",
  LOADING_TOGGLE: "loadingToggle",
  SET_SUBMISSION_STATUS: "setSubmissionStatus",
};

// Define the state's initial values.
export const initialState = {
  maxPhotoCount: 10,
  imageObjects: [],
  processingImage: false,
  condition: true,
  selectedFeature: { value: "", label: "Select Feature Type..." },
  comments: "",
  sdeTable: "",
  status: "",
  preview: null,
  formValid: false,
  loading: false,
  address: "",
  location: null,
  formImageError: false,
  submissionStatus: "",
};

const initializeForm = (state, selectedPhotoPoint) => {
  state.location = selectedPhotoPoint.LOCATION;
  state.comments = selectedPhotoPoint?.COMMENTS
    ? selectedPhotoPoint.COMMENTS
    : "";
  state.condition = selectedPhotoPoint?.CONDITION
    ? selectedPhotoPoint.CONDITION.toLowerCase() === "good"
    : true;
  if (selectedPhotoPoint?.FEATURE) {
    let label = features
      .filter((feature) => feature.feature === selectedPhotoPoint.FEATURE)
      .map((feature) => {
        return feature.label;
      });
    state.selectedFeature = {
      label: label[0],
      value: selectedPhotoPoint.FEATURE,
    };
  } else {
    state.selectedFeature = initialState.selectedFeature;
  }
  if (selectedPhotoPoint?.SDE_TABLE) {
    state.sdeTable = selectedPhotoPoint.SDE_TABLE;
  }
};

// Define the component's reducer with an action switch and state handling.
export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.RESET_STATE:
      state = initialState;
      return {
        ...state,
      };
    case ACTIONS.INITIALIZE_FORM:
      initializeForm(state, action.value);
      return {
        ...state,
      };
    case ACTIONS.CONDITION_TOGGLE:
      return {
        ...state,
        condition: state.condition ? false : true,
      };
    case ACTIONS.COMMENTS_INPUT:
      return {
        ...state,
        comments: action.value,
      };
    case ACTIONS.FEATURE_SELECTED:
      return {
        ...state,
        selectedFeature: action.value,
        formValid: action.value && state.imageObjects.length > 0,
      };
    case ACTIONS.PROCESSING_IMAGE:
      return {
        ...state,
        processingImage: state.processingImage ? false : true,
      };
    case ACTIONS.SET_STATUS:
      return {
        ...state,
        status: action.value,
        formImageError: false,
        loading: false,
      };
    case ACTIONS.UPDATE_IMAGE_OBJECTS:
      return {
        ...state,
        imageObjects: action.value,
        formValid: state.selectedFeature.value && action.value.length > 0,
      };
    case ACTIONS.REMOVE_PHOTO:
      let index = action.value;
      let tempArray = [...state.imageObjects];
      tempArray.splice(index, 1);
      return {
        ...state,
        imageObjects: tempArray,
        preview: null,
        formValid: state.selectedFeature.value && tempArray.length > 0,
      };
    case ACTIONS.SET_PREVIEW:
      return {
        ...state,
        preview: action.value,
      };
    case ACTIONS.SET_ADDRESS:
      return {
        ...state,
        address: action.value,
      };
    case ACTIONS.FORM_IMAGE_ERROR:
      return {
        ...state,
        formImageError: true,
        status: action.value,
      };
    case ACTIONS.LOADING_TOGGLE:
      return {
        ...state,
        loading: state.loading ? false : true,
      };
    case ACTIONS.SET_SUBMISSION_STATUS:
      return {
        ...state,
        loading: false,
        submissionStatus: action.value,
      };
    default:
      return state;
  }
};
